import { render, staticRenderFns } from "./MarqueeListPage.vue?vue&type=template&id=e4822eb4"
import script from "./MarqueeListPage.vue?vue&type=script&lang=js"
export * from "./MarqueeListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports